module.exports = __webpack_public_path__ + "a43f188ca3ce71f40cf52592be880b47.jpg";